import greedySplit from 'greedy-split';
import connectMessageChannel from 'message-channel/connect';
import { BaseStorage } from '../base-storage';
import { CONNECTION_MAX_TIMEOUT, MESSAGE_MAX_TIMEOUT, toError, } from '../utils/constants';
export class FrameStorageStrategy extends BaseStorage {
    constructor(target, origin, token, { connectionMaxTimeout = CONNECTION_MAX_TIMEOUT, messageMaxTimeout = MESSAGE_MAX_TIMEOUT, } = {}) {
        super();
        this.target = target;
        this.origin = origin;
        this.token = token;
        this.channel = undefined;
        this.connectionMaxTimeout = connectionMaxTimeout;
        this.messageMaxTimeout = messageMaxTimeout;
    }
    getChannel() {
        if (this.channel) {
            return Promise.resolve(this.channel);
        }
        return connectMessageChannel('data-capsule', {
            target: this.target,
            origin: this.origin,
            connectionMaxTimeout: this.connectionMaxTimeout,
            messageMaxTimeout: this.messageMaxTimeout,
        }).then((channel) => {
            this.channel = channel;
            return channel;
        });
    }
    sendCommand(method, ...params) {
        const payload = { data: params };
        return this.getChannel().then((sendToChannel) => {
            const message = [this.token, method, JSON.stringify(payload)].join('|');
            return sendToChannel(message).then((e) => {
                const [status, eventPayload] = greedySplit(e.data, '|', 2);
                if (status === 'reject') {
                    throw toError(eventPayload);
                }
                return JSON.parse(eventPayload).data;
            });
        });
    }
    setItem(key, value, options) {
        return this.sendCommand('setItem', key, value, options);
    }
    getItem(key, options) {
        return this.sendCommand('getItem', key, options);
    }
    removeItem(key, options) {
        return this.sendCommand('removeItem', key, options);
    }
    getAllItems(options) {
        return this.sendCommand('getAllItems', options);
    }
}
//# sourceMappingURL=frame-storage.js.map